/* eslint-disable no-plusplus */
let counter = 0;
const events = {
  MAKE: 'MAKE',
  CLOSE: 'CLOSE',
  CLOSE_ALL: 'CLOSE_ALL'
};

const ToastManager = () => {
  let eventCallbacks = {};
  let eventQueue = [];
  let started = false;

  function enqueueEvent(event) {
    eventQueue.push(event);
  }

  function triggerEvent(event) {
    // Queue events until toaster is warm enough and properly mounted
    if (!started) {
      return enqueueEvent(event);
    }

    const {
      eventType,
      payload
    } = event;
    return eventCallbacks[eventType](payload);
  }

  function start() {
    started = true; // Trigger all enqueued events

    eventQueue.forEach(triggerEvent);
    eventQueue = [];
  }

  function setup({
    onMake,
    onClose,
    onCloseAll
  }) {
    if (process.env.NODE_ENV !== "production" && started) {
      // eslint-disable-next-line no-console
      console.error('Only one Toaster is allowed to be rendered');
    }

    eventCallbacks = {
      [events.MAKE]: onMake,
      [events.CLOSE]: onClose,
      [events.CLOSE_ALL]: onCloseAll
    };
    start();
  }

  function stop() {
    started = false;
    eventCallbacks = {};
    eventQueue = [];
  }

  function make(content, options) {
    const id = counter++;
    triggerEvent({
      eventType: events.MAKE,
      payload: {
        id,
        content,
        options
      }
    });
    return id;
  }

  function close(toastId) {
    return triggerEvent({
      eventType: events.CLOSE,
      payload: toastId
    });
  }

  function closeAll() {
    return triggerEvent({
      eventType: events.CLOSE_ALL
    });
  }

  function isStarted() {
    return started;
  }

  return {
    setup,
    stop,
    make,
    close,
    closeAll,
    isStarted
  };
};

const toastManager = ToastManager();
export { toastManager };